import { Box, Image, Link } from "components/base";
import { Container, ContainerFluid, Flex } from "components/base/container";
import { GradientBorderBtn } from "components/element/element.button";
import { DiscordIcon, TelegramIcon, TwitterIcon } from "components/icon/icon.normal";

const LayoutFooter = () => {
  return (
    <ContainerFluid bg={"normal"}>
      <Container
        flexDirection={["column-reverse", "column-reverse", "row"]}
        alignItems={"center"}
        gridGap={["52px", "52px", "52px", "90px", "138px"]}
        py={"84px"}
      >
        <Flex col alignItems={["center", "center", "unset"]}>
          <Flex flexDirection={["column", "column", "row"]} alignItems={"center"} gridGap={"14px"}>
            <Image src={require("assets/image/logo.png")} width={"70px"} />
            <Flex width={["133px", "133px", "150px", "167px"]}>
              <Image src={require("assets/image/logo_title.svg").default} width={"100%"} />
            </Flex>
          </Flex>
          <Flex mt={["32px", "32px", "45px", "58px"]} fontSize={"24px"} color={"light"} gridGap={"12px"}>
            <Link target="blank" href={"https://discord.com/invite/pvaupekRmB"}>
              <DiscordIcon />
            </Link>
            <Link target="blank" href={"https://twitter.com/SnotraQ"}>
              <TwitterIcon />
            </Link>
          </Flex>
          <Flex mt={"12px"}>info@snotra.com</Flex>
        </Flex>
        <Flex col>
          <Flex fontWeight={"400"} fontSize={"18px"} lineHeight={"140%"}>
            Snotra is a revenue sharing staking-as-a-service platform focused on quality, speed, and self-service. Free and painless set-up for the
            project owner. Revenue stream generated through small transaction fees will be shared with Snotra NFTs holders
          </Flex>
          <Flex flexDirection={["column", "column", "row"]} alignItems={"center"} mt={"32px"} gridGap={["16px", "16px", "20px", "24px"]}>
            <GradientBorderBtn href="https://discord.com/invite/pvaupekRmB">Join our DisCord</GradientBorderBtn>
            <GradientBorderBtn href="https://twitter.com/SnotraQ">Follow us on twitter</GradientBorderBtn>
          </Flex>
        </Flex>
      </Container>
    </ContainerFluid>
  );
};

export default LayoutFooter;
